import React, { useEffect, useState } from 'react';
import EventSliderTile from './EventSliderTile';
import './EventSliderComponent.scss';
import { useStateValue } from '../../services/ContextProvider';
import { getProjectsToEventSlider } from '../../services/ProjectService';
import { Link, NavLink } from 'react-router-dom';

const data = [
    {
        title: 'Fund Raiser 2021',
        imgUri: '/images/carouselimages/carousel4.jpg',
    },
    {
        title: 'Fund Raiser 2021',
        imgUri: '/images/carouselimages/carousel1.jpg',
    },
    {
        title: 'Fund Raiser 2021',
        imgUri: '/images/carouselimages/carousel2.jpg',
    },
    {
        title: 'Fund Raiser 2021',
        imgUri: '/images/carouselimages/carousel3.jpg',
    },
    {
        title: 'Fund Raiser 2021',
        imgUri: '/images/carouselimages/carousel5.jpg',
    },
    {
        title: 'Fund Raiser 2021',
        imgUri: '/images/carouselimages/carousel11.jpg',
    },
    {
        title: 'Fund Raiser 2021',
        imgUri: '/images/carouselimages/carousel21.jpg',
    },
    {
        title: 'Fund Raiser 2021',
        imgUri: '/images/carouselimages/carousel51.jpg',
    },
    {
        title: 'Fund Raiser 2021',
        imgUri: '/images/carouselimages/carousel41.jpg',
    },
];

const getData = async () => {
    setTimeout(() => {
        return data;
    }, 1000);
};

const EventSliderComponent = () => {
    const [dataItems, setDataItems] = useState([]);
    const [intervalFn, setIntervalFn] = useState(null);
    const [tileSize, settileSize] = useState(450);
    const [rowGap, setrowGap] = useState(10);
    const [moveUnitDistance, setmoveUnitDistant] = useState(tileSize + rowGap);
    const [moveDistance, setmoveDistance] = useState(0);
    //const [halt, sethalt] = useState(false);
    const [gridColumns, setgridColumns] = useState(0);
    const [gridRows, setgridRows] = useState(0);
    const [eventGridMargin, seteventGridMargin] = useState(0);
    const [gridTopMargin, setgridTopMargin] = useState(0);
    const [gridShowHeight, setgridShowHeight] = useState(0);
    const [gridGuideArray, setgridGuideArray] = useState([]);
    const [activeRowNum, setactiveRowNum] = useState(0);
    const [activeEvent, setactiveEvent] = useState({
        firstActiveEvent: 0,
        lastActiveEvent: 0
    });
    var activeRowNumber = 0;
    const [intervalTime, setintervalTime] = useState(3000);
    const [jumpRow, setjumpRow] = useState(-1);
    const [jumping, setjumping] = useState(false);
    const [halt, sethalt] = useState(false);
    const [timeoutFn, settimeoutFn] = useState(null);
    var columns = 0;
    var gridGuideTempArray = [];

    useEffect(() => {

    }, []);

    useEffect(() => { //////////////////////////// MAIN LISTNER ///////////
        activeRowNumber = 0;
        resize();
        if (intervalFn) {
            clearInterval(intervalFn);
        }
        eventPledgetimer();
        window.addEventListener('resize', resize);
        return () => {
            clearInterval(intervalFn);
            setIntervalFn(null);
            window.removeEventListener('resize', resize);
        };
    }, [data, gridRows, moveUnitDistance]);

    const setEventSliderValues = (gridTileSize, topMargin, gridLRMargins, showHeight) => { ///// RESIZE SUBFUNCTION ///
        settileSize(gridTileSize);
        setgridTopMargin(topMargin);
        seteventGridMargin(gridLRMargins);
        setmoveUnitDistant(gridTileSize + rowGap);
        columns = Math.floor((window.innerWidth - 2 * gridLRMargins) / gridTileSize);
        setgridShowHeight(showHeight);
    };

    const eventCarouselHalt = (value) => {
        // halt = value;
    };

    const resize = () => { //////////////////////////// RESPONSIVE RESIZE ///////////////
        if (window.innerWidth > 1600) {
            setEventSliderValues(450, 200, 100, 650);
        } else if (window.innerWidth > 1000) {
            setEventSliderValues(350, 165, 100, 500);
        } else if (window.innerWidth > 900) {
            setEventSliderValues(350, 175, 60, 500);
        } else if (window.innerWidth > 800) {
            setEventSliderValues(300, 150, 20, 500);
        } else if (window.innerWidth > 720) {
            setEventSliderValues(300, 180, 20, 470);
        } else if (window.innerWidth > 600) {
            setEventSliderValues(450, 50, 20, 400);
        } else if (window.innerWidth > 400) {
            setEventSliderValues(350, 150, 5, 520);
        } else if (window.innerWidth > 300) {
            setEventSliderValues(280, 150, 5, 480);
        }

        setgridColumns(columns);
        let rows = Math.ceil(data.length / columns);
        setgridRows(rows);
        setactiveEvent(
            {
                firstActiveEvent: 0,
                lastActiveEvent: columns,
            }
        );
        gridGuideTempArray = [];
        for (let i = 0; i < rows; i++) {
            gridGuideTempArray.push(i);
        }
        setgridGuideArray(arr => gridGuideTempArray);
    };

    const moveGrid = (tempColumns, jump, jumpTo) => { ///////////////// MOVING THE TILES //////////
        //console.log(gridRows, activeRowNumber);
        if (!jump) {
            let val = 0;
            let tempGridRows = 0;
            let tempMoveUnit = 0;
            setactiveRowNum(prev => {
                val = prev; return prev;
            });
            setgridRows(prev => {
                tempGridRows = prev; return prev;
            });
            setmoveUnitDistant(prev => {
                tempMoveUnit = prev; return prev;
            });
            if (tempGridRows <= val) {
                val = 0;
                setmoveDistance(distance => 0);
                setactiveEvent(
                    {
                        firstActiveEvent: 0,
                        lastActiveEvent: tempColumns,
                    }
                );
            } else {
                //console.log(gridRows, tempColumns);
                setmoveDistance(distance => -(val * tempMoveUnit));
                setactiveEvent(prev => {
                    return {
                        firstActiveEvent: val * tempColumns,
                        lastActiveEvent: val * tempColumns + tempColumns,
                    };
                });
            }
            setactiveRowNum(prev => val + 1);
        } else {
            setmoveDistance(distance => -(jumpTo * moveUnitDistance));
            setactiveEvent(prev => {
                return {
                    firstActiveEvent: jumpTo * tempColumns,
                    lastActiveEvent: jumpTo * tempColumns + tempColumns,
                };
            });
            setactiveRowNum(jumpTo);
        }
    };


    useEffect(() => { ///////////////////////////// JUMP LISTNER ///////////
        if (jumping) {
            let tempColumns = Math.ceil(data.length / gridRows);
            sethalt(true);
            if (timeoutFn) {
                clearTimeout(timeoutFn);
            }
            setjumping(false);
            moveGrid(tempColumns, true, jumpRow);
            setactiveRowNum(prev => prev + 1);
            let tf = setTimeout(() => {
                sethalt(false);
            }, 3000);
            settimeoutFn(tf);
        }
    }, [jumpRow]);

    const eventPledgetimer = () => { //////////////////////////// CAROUSEL AUTORUN //////////
        let tempColumns = Math.ceil(data.length / gridRows);
        //console.log(halt);
        let i = setInterval(() => {
            let halt = false;
            sethalt(prev => {
                halt = prev; return prev;
            });
            if (!halt) {
                moveGrid(tempColumns, false);
            }
        }, intervalTime);
        setIntervalFn(i);
    };

    const { eventlistState, eventlistDispatch } = useStateValue();
    const [tiledata, setTiledata] = useState([]);

    const getEventList = async () => {
        try {
            if (eventlistState.projectList.length === 0) {
                await getProjectsToEventSlider(eventlistDispatch, eventlistState.projectList);

                return true;
            }
        } catch {
            return false;
        }
    };

    getEventList();

    useEffect(() => {
        setTiledata(eventlistState.projectList);
        console.log(eventlistState.projectList);
    }, [eventlistState]);


    return (
        <div className="EventSliderComponent mt-4 " >
            <div className="home-events-title"><h className="contactus-heading" data-aos="fade-down">What&nbsp;<span className="sub-contactus-heading">We Do?</span></h></div>
            <div
                className="EventSlider-container"
                style={{
                    gridTemplateColumns: `repeat(${gridColumns}, 1fr)`,
                    gridTemplateRows: `repeat(${gridRows} ,${tileSize}px)`,
                    rowGap: `${rowGap}px`,
                    marginLeft: `${eventGridMargin}px`,
                    marginRight: `${eventGridMargin}px`,
                    paddingTop: `${gridTopMargin / 2}px`,
                    height: `${gridShowHeight}px`
                }}
            >
                {
                    <div className='event-carousel-guides-grid'>
                        {
                            gridGuideArray.map(item => (
                                <div
                                    key={item}
                                    className={`event-carousal-guide ${activeRowNum - 1 === item ? 'active' : ''}`}
                                    onClick={() => { setjumping(true); setjumpRow(item); }}
                                ></div>
                            ))
                        }
                    </div>
                }
                {
                    tiledata.map((item, index) => {
                        return (
                            <EventSliderTile
                                key={index}
                                id={item.id}
                                title={item.title}
                                imgUri={item.thumbnailimageURL}
                                tileSize={tileSize}
                                rowGap={rowGap}
                                transformSize={moveDistance}
                                onHoverFunction={sethalt}
                                active={index >= activeEvent.firstActiveEvent && index < activeEvent.lastActiveEvent}
                            />
                        );
                    })
                }
            </div>
            <div className="event-carousel-btn-container">
                <NavLink to='/projects' style={{ textDecoration: 'none', color: 'rgb(90, 90, 90)' }}>
                    <div className="event-carousel-view-more-btn" ><span>
                        View All Projects
                    </span></div>
                </NavLink>
            </div>
        </div>
    );
};

export default EventSliderComponent;
